export type RouterRouteId = {
    id: string
}

type ExternalAction = 'cancel' | 'save' | 'delete'

type handleExternalActionVoid = (action: ExternalAction, id?: string) => void

export const handleExternal: handleExternalActionVoid = (action, id) => {
    const jsonAction = JSON.stringify({
        action,
        id,
    })

    // @ts-expect-error TS(2339) FIXME: Property 'ReactNativeWebView' does not exist on ty... Remove this comment to see the full error message
    if (window.ReactNativeWebView) {
        // @ts-expect-error TS(2339) FIXME: Property 'ReactNativeWebView' does not exist on ty... Remove this comment to see the full error message
        window.ReactNativeWebView.postMessage(jsonAction)
    } else {
        window.parent.postMessage(jsonAction, '*')
    }
}

export type RouterErrorProps = {
    hasNoHcsLinkedError?: boolean
}
